<template>
    <svg height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd" stroke="currentColor">
            <!-- @vue-ignore -->
            <circle cx="48" cy="48" r="39" stroke-width="2" />
            <!-- @vue-ignore -->
            <circle cx="35.5" cy="38.1" fill="#222" r="2.1" stroke-width="4.8" />
            <!-- @vue-ignore -->
            <g stroke-width="2">
                <path
                    d="m33.6 54.5526192c.919162 7.1337208 7.0156826 12.6455788 14.3995667 12.6455788 7.3862088 0 13.4842435-5.5153293 14.4004333-12.6523173"
                />
                <!-- @vue-ignore -->
                <path d="m62.9999739 33.8751058-6.8441942 6.9248942h9.558506" stroke-linejoin="round" />
            </g>
        </g>
    </svg>
</template>
